import React from "react";
import { useGameState } from "context/GameContext";
// Css
import classes from "./Players.module.scss";

const Players: React.FC = () => {
  const { players } = useGameState();

  return (
    <>
      {players.map((player, index) => (
        <div className={classes.container} key={player.id}>
          {index + 1 + "." + player.name}
        </div>
      ))}
    </>
  );
};

export default Players;
